var map = {
	"./compress.png": "08ff",
	"./docs.png": "f61b",
	"./exe.png": "1a4c",
	"./html.png": "21fa",
	"./pdf.png": "96a6",
	"./txt.png": "69f6",
	"./unknown.png": "4827"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5559";